import type IGenerateMockEntityIdentityOptions from './interfaces/IGenerateMockEntityIdentityOptions';
import type IMockEntityIdentity from './interfaces/IMockEntityIdentity';

const getRandomAlphaNumeric = (length: number) => Math.random()
  .toString(36)
  .toUpperCase()
  .replace(/[^A-Z0-9]/g, '')
  .slice(0, length)
  .padEnd(length, '0');

function generateMockEntityIdentity({
  baseName,
  codePrefix,
}: IGenerateMockEntityIdentityOptions): IMockEntityIdentity {
  const nameSuffix = getRandomAlphaNumeric(4);
  const identifierSuffix = `${Date.now()}${getRandomAlphaNumeric(4)}`;
  const normalizedPrefix = codePrefix.toUpperCase().replace(/[^A-Z0-9]/g, '');

  return {
    name: `${baseName} ${nameSuffix}`,
    code: `${normalizedPrefix}${getRandomAlphaNumeric(6)}`,
    uniqueIdentifier: `${normalizedPrefix}${identifierSuffix}`,
  };
}

export default generateMockEntityIdentity;
